/**
 * Tokens de marca FIVI360 realmente estáveis.
 *
 * Não substituem Tailwind. Não governam o produto via CSS variables.
 * O produto é dark-only hardcoded — não ativar `.dark`.
 *
 * Destino futuro: packages/brand. Hoje vivem em src/components/common/
 * por coesão com BrandLogo.
 */

/** Fundo institucional (body, shells). */
export const BRAND_BACKGROUND = "#050505";

/** Borda institucional (headers, cards, chrome). */
export const BRAND_BORDER_CLASS = "border-zinc-800";

/** Texto secundário institucional. */
export const BRAND_MUTED_TEXT_CLASS = "text-zinc-400";

/**
 * Container público institucional (Home / chrome legal).
 * Não inclui padding de seção, background nem min-height.
 */
export const PUBLIC_CONTAINER_CLASS =
  "max-w-7xl mx-auto px-6 md:px-12 lg:px-16";

/**
 * CTA pill de marca — string usada pelos CTAs institucionais da Home
 * (Hero, Showcase, Portfolio). Padding/tamanho variam em outros
 * consumidores; eles continuam com classes locais até migrarem.
 */
export const BRAND_BUTTON_CLASS =
  "bg-white text-black rounded-full px-6 py-3 font-medium btn-scale hover:bg-zinc-200 h-auto text-sm";

/**
 * Alturas semânticas do wordmark.
 * `sm` é o default histórico de BrandLogo (`h-4 md:h-5`).
 * Consumidores existentes que passam className NÃO foram migrados.
 */
export const BRAND_LOGO_SIZES = {
  sm: "h-4 md:h-5",
  md: "h-7",
};

/** Classe default histórica de BrandLogo (size omitido). */
export const BRAND_LOGO_DEFAULT_CLASS = "h-4 md:h-5 w-auto object-contain";
